/** @format */

export interface CompareBarProduct {
  compareSource?: string;
  ecode: string;
  gridImageURL?: string;
  imgURL: string;
  name: string;
  pdpURL: string;
}
